<template><div><h1 id="op-zahlungsarten" tabindex="-1"><a class="header-anchor" href="#op-zahlungsarten"><span>OP-Zahlungsarten</span></a></h1>
<p>OP-Zahlungsarten — Auswertung der Zahlungsarten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit den <RouteLink to="/referenz/refs/ft.refdata.tblzahlungsarten.html" title="Zahlungsarten">Zahlungsarten</RouteLink>. Die Auswertung listet die verwendeten Zahlungsarten mit Anzahl und Umsatz unterteilt nach Jahr und Monat auf. Die Zahlunsgart zu einer Buchung ist in den <RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">manuellen Buchungen</RouteLink> abgelegt.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Zahlungsarten</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Jahr von</dt>
<dd>Einschränkung nach Jahr von</dd>
<dt>bis</dt>
<dd>Einschränkung auf Jahr bis</dd>
</dl>
</div></template>


